module.exports = __webpack_public_path__ + "img/tanisia.79edbf6.webp";